import styled from 'styled-components';
import { IonModal } from '@ionic/react';

type ModalSuccessContainerProps = {
  alignItems?: 'start' | 'end' | 'center';
};

export const ModalSuccessContainer = styled.div<ModalSuccessContainerProps>`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: ${(props) => props?.alignItems ?? 'center'};
  justify-content: center;
  margin-bottom: calc(20px + var(--ion-safe-area-top));
  text-align: center;

  & ion-icon {
    width: 60px;
    height: 60px;
    color: #26b183;
    margin-bottom: 20px;
  }

  .text {
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    color: #1d201f;
    margin-bottom: 2px;
  }

  & span {
    margin-top: 5px;
    font-size: 18px;
    line-height: 14px;
    color: #1d201f;
  }
`;

export const PaymentModalStyled = styled(IonModal)`
  --width: 100%;
  --height: 100%;
`;
